module.exports = __webpack_public_path__ + "static/water_glacier20-6af204331dc03c72e0f39f4389db76a2.jpg";